import controller from './orderAtTable.controller';
import template from './orderAtTable.html';

const OrderAtTableDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default OrderAtTableDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAtTable/orderAtTable.component.js
 **/